import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type NavOrigin = 'home' | 'appbar' | 'drawer' | 'direct';

@Injectable({
  providedIn: 'root'
})
export class AppBarStateService {
  // Origen de navegación actual
  private navOriginSubject = new BehaviorSubject<NavOrigin>('direct');
  public navOrigin$: Observable<NavOrigin> = this.navOriginSubject.asObservable();

  // Visibilidad efectiva de la barra flotante
  private barVisibleSubject = new BehaviorSubject<boolean>(true);
  public barVisible$: Observable<boolean> = this.barVisibleSubject.asObservable();

  get currentOrigin(): NavOrigin {
    return this.navOriginSubject.value;
  }

  get isBarVisible(): boolean {
    return this.barVisibleSubject.value;
  }

  /**
   * Establece el origen de navegación previo a la transición de ruta
   */
  setNavOrigin(origin: NavOrigin) {
    this.navOriginSubject.next(origin);
  }

  /**
   * Actualiza si la barra debe verse en la ruta actual
   */
  updateVisibility(currentUrl: string, configEnabled: boolean) {
    if (!configEnabled) {
      this.barVisibleSubject.next(false);
      return;
    }

    const isHome = currentUrl.includes('/menu/home') || currentUrl === '/menu' || currentUrl === '/';
    if (isHome) {
      // En Home siempre visible si está habilitada
      this.barVisibleSubject.next(true);
      return;
    }

    // Subrutas de configuración/edición nunca deben mostrar la barra flotante principal
    const isSubRoute = currentUrl.includes('/menu/ajustes/') || 
                       currentUrl.includes('/accesos') || 
                       currentUrl.includes('/admin-crud') ||
                       currentUrl.includes('/login');

    if (isSubRoute) {
      this.barVisibleSubject.next(false);
      return;
    }

    // Si viene del menú lateral (drawer), la barra se oculta en la página destino
    if (this.currentOrigin === 'drawer' || this.currentOrigin === 'direct') {
      this.barVisibleSubject.next(false);
    } else {
      // Si navegó desde el Home o desde la Barra flotante
      this.barVisibleSubject.next(true);
    }
  }
}

